import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NotificationsPreferenceEntry } from '@freelancer/datastore/collections';
import { IconSize } from '@freelancer/ui/icon';
import { ListItemType } from '@freelancer/ui/list-item';
import { Margin } from '@freelancer/ui/margin';
import {
  FontType,
  FontWeight,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';
import { NavigationUpdatesView } from '../../updates.model';

@Component({
  selector: 'app-updates-settings-list',
  template: `
    <fl-bit class="Heading">
      <fl-button
        flTrackingLabel="UpdatesSettings-Back"
        [flMarginRight]="Margin.XXSMALL"
        (click)="handleBack()"
      >
        <fl-icon [name]="'ui-arrow-left-alt'" [size]="IconSize.SMALL"></fl-icon>
      </fl-button>
      <fl-text
        i18n="Updates Settings heading"
        [flMarginRight]="Margin.MID"
        [size]="TextSize.XXSMALL"
        [textTransform]="TextTransform.UPPERCASE"
        [weight]="FontWeight.BOLD"
      >
        Notification Settings
      </fl-text>
    </fl-bit>
    <fl-bit class="List" *ngIf="filters && filters.length > 0">
      <fl-text class="List-hint" i18n="Mark project categories updates hint">
        Please mark the categories of projects that you would like to receive
        notifications about.
      </fl-text>
      <fl-checkbox
        class="List-content"
        *ngFor="let filter of filters"
        flTrackingLabel="UpdateSettings-{{ filter.channel | pascalCase }}"
        [control]="settingsForm.get(filter.channel)"
        [label]="filter.name"
      ></fl-checkbox>
    </fl-bit>
  `,
  styleUrls: ['./updates-settings-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdatesSettingsListComponent {
  TextSize = TextSize;
  FontType = FontType;
  FontWeight = FontWeight;
  IconSize = IconSize;
  ListItemType = ListItemType;
  Margin = Margin;
  TextTransform = TextTransform;

  @Input() filters: ReadonlyArray<NotificationsPreferenceEntry>;
  @Input() settingsForm: FormGroup;

  @Output() clickBack = new EventEmitter<NavigationUpdatesView>();

  handleBack() {
    this.clickBack.emit(NavigationUpdatesView.LIST);
  }
}
